import { NestedMenuItem } from 'mui-nested-menu'
import classNames from 'classnames/bind'
import styles from './NavbarItem.module.scss'
import { INavbarItem } from '../../Navbar.component'
import ChevronRight from '@mui/icons-material/ChevronRight'
import {
  currentTheme,
  drawerSetting,
  selectAuth,
  setDrawerSetting
} from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { t } from 'i18next'
import { Link, useLocation } from 'react-router-dom'
import { MenuItem } from '@mui/material'
import { useState } from 'react'
import { CheckRole } from '~/utils'
import { useDispatch } from 'react-redux'

const cx = classNames.bind(styles)
interface INestedMenuItemProps {
  navItem: INavbarItem
  validRole: boolean
  isMobile: boolean
}
export const NestedMenuItemComponent = ({ navItem, validRole, isMobile }: INestedMenuItemProps) => {
  const { roles } = useAppSelector(selectAuth)
  const { isShowDrawer } = useAppSelector(drawerSetting)

  const location = useLocation()
  const dispatch = useDispatch()
  const theme = useAppSelector(currentTheme)
  const [subMenuSeleted, setSubMenuSeleted] = useState('')
  return (
    <NestedMenuItem
      key={navItem.name}
      aria-hidden='true'
      title={navItem.name}
      leftIcon={
        <navItem.icon
          height={34}
          width={34}
        />
      }
      rightIcon={isShowDrawer ? <ChevronRight /> : null}
      label={isShowDrawer ? navItem.name : ''}
      parentMenuOpen={true}
      MenuProps={{
        PaperProps: { className: cx('submenu-popover', theme) }
      }}
      className={cx(
        'nav-item',
        `navbar-item-text`,
        'nav-item-with-nested-menu',
        theme,
        {
          hide: !validRole
        },
        { hover: subMenuSeleted.includes(navItem.path) },
        {
          active: location.pathname.includes(navItem.path)
        }
      )}
    >
      {navItem.subMenu?.map(
        subItem =>
          subItem && (
            <Link
              onMouseEnter={() => setSubMenuSeleted(subItem.path)}
              onMouseLeave={() => setSubMenuSeleted('')}
              key={subItem.path}
              className={cx('nav-link', {
                hide: !validRole
              })}
              to={subItem.path}
              title={subItem.name}
              target={
                subItem.name === t('PageTitle_Swagger') ||
                subItem.name === t('PageTitle_HangFire')
                  ? '_blank'
                  : '_self'
              }
              rel='noopener noreferrer'
            >
              <MenuItem
                key={subItem.name}
                className={cx(
                  'nav-item',
                  'nav-sub-item',
                  theme,
                  { hide: !CheckRole(subItem.requireRoles ?? [], roles) },
                  {
                    active:
                      !!subItem.path && location.pathname.startsWith(subItem.path)
                  }
                )}
                selected={
                  !!subItem.path && location.pathname.startsWith(subItem.path)
                }
                onMouseUp={() => {
                  isMobile && dispatch(setDrawerSetting({ isShowDrawer: false }))
                }}
              >
                {subItem.name}
              </MenuItem>
            </Link>
          )
      )}
    </NestedMenuItem>
  )
}
